(() => {
  function setup(root) {
    if (root.dataset.saReady) return;
    root.dataset.saReady = 'true';
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    const activate = tab => {
      tabs.forEach(item => { const selected = item === tab; item.setAttribute('aria-selected', String(selected)); item.tabIndex = selected ? 0 : -1; document.getElementById(item.getAttribute('aria-controls')).hidden = !selected; });
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault(); activate(tabs[next]); tabs[next].focus();
      });
    });
    root.querySelectorAll('[data-sa-scroll]').forEach(button => {
      const rail = button.closest('[role="tabpanel"]').querySelector('.sa-sage-products');
      const update = () => {
        button.disabled = Number(button.dataset.saScroll) < 0 ? rail.scrollLeft <= 1 : rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 1;
      };
      button.addEventListener('click', () => rail.scrollBy({left: Number(button.dataset.saScroll) * rail.clientWidth * .85, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'}));
      rail.addEventListener('scroll', update, {passive:true});
      new ResizeObserver(update).observe(rail); update();
    });
  }
  document.querySelectorAll('[data-sa-catalog]').forEach(setup);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-sa-catalog]').forEach(setup));
})();